import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import App from './App';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
// import Main from "./Main";
import Join from "./pages/Join";
import EventsPage from "./pages/EventsPage";
// import {Events} from "./sections/Events";
import Home from "./Home";
import theme from "./theme";
import {ThemeProvider} from "@mui/material";
import About from "./pages/About";
// import Header from "./Header";
import ProjectPage from "./pages/ProjectPage";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <ThemeProvider theme={theme}>
      <Router>
          <Routes>
              {/*<Route path="/" element={<Main />} />*/}
              <Route path="/" element={<Home />} />
              <Route path="/join" element={<Join />} />
              <Route path="/about" element={<About />}  />
              <Route path="/events" element={<EventsPage />} />
              {/*<Route path="projects/" >*/}
              {/*    <Route path="orion" element={<ProjectPage />} />*/}
              {/*    <Route path="atlas" element={<ProjectPage />} />*/}
              {/*    <Route path="hermes" element={<ProjectPage />} />*/}
              {/*    <Route path="icarus" element={<ProjectPage />} />*/}
              {/*</Route>*/}
              <Route path="projects/">
                  <Route path=":projectId" element={<ProjectPage />} />
              </Route>
          </Routes>

      </Router>
      </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
